import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "https://link.conexa.com.pe/";

export const shortenUrl = async (originalUrl) => {
    try { 
        const response = await axios.post(`${API_BASE_URL}/shorten`, { originalUrl });
        return {
            ...response.data,
            shortUrl: `${API_BASE_URL}/${response.data.shortUrl.split('/').pop()}`
        };
    } catch (error) {
        console.error("Error acortando la URL:", error);
        return null;
    }
};

export const getAllUrls = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/list`);
        return response.data;
    } catch (error) {
        console.error("Error obteniendo las URLs:", error);
        return [];
    }
};
